<!-- <waitLoading *ngIf="!isLoaded()"></waitLoading> -->
<ng-container *ngIf="isLoaded()">
  <div class="col-12">
    <h3>{{ 'TenderEvaluationCommittee.title' | translate }}</h3>
  </div>
  <div class="col-12">
    <p-table [value]="data" sortField="description" [responsive]="true">
      <ng-template pTemplate="header">
        <tr>
          <th [style.width]="'65%'">{{ colHeaders[0] | translate }}</th>
          <th [style.width]="'25%'"> {{ colHeaders[1] | translate }} </th>
          <th [style.width]="'10%'">{{ colHeaders[2] | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-committe>
        <tr>
          <td>
            <span class="p-column-title">{{ colHeaders[0] | translate }}</span> {{ committe.description }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[1] | translate }}</span> {{
            committe.memberTenderEvaluationCommittee?.length || 0 }} / {{ committe.quorum || 0 }}
          </td>
          <td>
            <span class="p-column-title">{{ colHeaders[2] | translate }}</span>
            <div class="btn-group">
              <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false" (click)="editData(committe)"
                appNoDblClick title="{{ 'General.edit' | translate}}" tooltipPosition="top">
                <i class="fas fa-pencil-alt" aria-hidden="true"></i>
              </button>
              <button class="btn btn-sm btn-secondary t-action-button"
                [attr.disabled]="!canDelete(committe) ? 'disabled' : null" aria-expanded="false"
                title="{{ 'General.delete' | translate}}" (click)="deleteData(committe)" appNoDblClick
                tooltipPosition="top">
                <i class="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="text-center">
          <td colspan="3">{{ 'General.noData' | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
    <div class="flex-row py-2" *ngIf="task?.workType !== 'DOSSIER_MC' || !data || data.length === 0">
      <div class="d-flex flex-row-reverse">
        <button class="btn btn-sm btn-outline-primary float-right" (click)="newData()" appNoDblClick
          title="{{ 'General.add' | translate}}">
          <i class="fas fa-plus"></i> {{ 'General.add' | translate }} </button>
      </div>
    </div>
  </div>
</ng-container>